import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
	selector: 'app-super-admin-top-navbar',
	standalone: true,
	imports: [MatMenuModule, MatIconModule, MatToolbarModule, MatIconModule, MatMenuModule, MatButtonModule,ReactiveFormsModule,
		FormsModule
	],
	templateUrl: './super-admin-top-navbar.component.html',
	styleUrl: './super-admin-top-navbar.component.scss'
})
export class SuperAdminTopNavbarComponent {
}
